import { render, staticRenderFns } from "./GraphFeedbackItems.vue?vue&type=template&id=32d6bcf6&"
import script from "./GraphFeedbackItems.vue?vue&type=script&lang=js&"
export * from "./GraphFeedbackItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports